import React from 'react';
import './VendorCarousel.css';

const VendorCarousel = () => {
  const allVendors = [
    { name: 'Microsoft', logo: 'https://upload.wikimedia.org/wikipedia/commons/4/44/Microsoft_logo.svg' },
    { name: 'Google Workspace', logo: 'https://upload.wikimedia.org/wikipedia/commons/5/5f/Google_Workspace_Logo.svg' },
    { name: 'Apple', logo: 'https://upload.wikimedia.org/wikipedia/commons/f/fa/Apple_logo_black.svg' },
    { name: 'Huntress', logo: '/vendor-logos/huntress-full.png' },
    { name: 'Cisco', logo: 'https://upload.wikimedia.org/wikipedia/commons/0/08/Cisco_logo_blue_2016.svg' },
    { name: 'Palo Alto Networks', logo: '/vendor-logos/paloalto.png' },
    { name: 'Sophos', logo: '/vendor-logos/sophos.png' },
    { name: 'Fortinet', logo: '/vendor-logos/fortinet.png' },
    { name: 'Bitdefender', logo: '/vendor-logos/bitdefender.png' },
    { name: 'NinjaOne', logo: '/vendor-logos/ninjaone.png' },
    { name: 'Auvik', logo: '/vendor-logos/auvik.png' },
    { name: 'SentinelOne', logo: '/vendor-logos/sentinelone.png' },
    { name: 'HPE Aruba Networking', logo: 'https://upload.wikimedia.org/wikipedia/commons/7/7c/Aruba_Networks_logo.svg' },
  ];

  return (
    <section className="py-16 px-4 sm:px-6 lg:px-8 bg-white overflow-hidden">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">Our Technology Partners</h2>
          <p className="text-lg text-gray-600">Over 20 Trusted Vendors We Work With</p>
        </div>
        <div className="relative">
          <div className="flex animate-scroll space-x-12">
            {[...allVendors, ...allVendors].map((vendor, index) => (
              <div key={index} className="vendor-logo-container flex-shrink-0 w-40 h-20 flex items-center justify-center bg-white rounded-lg shadow-sm hover:shadow-md transition-shadow duration-300 p-4">
                <img src={vendor.logo} alt={vendor.name} className="vendor-logo max-w-full max-h-full object-contain" onError={(e) => { e.target.style.display = 'none'; e.target.parentElement.innerHTML = '<span class="text-sm text-gray-600 font-medium">' + vendor.name + '</span>'; }} />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default VendorCarousel;
